
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46.4","height":"46","viewBox":"0 0 46.4 46"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"#57A969","cx":"23.2","cy":"23","r":"22.4"}}),_c('path',{attrs:{"fill":"#EFEFEA","d":"M19 34L8.4 23.4l3-2.9L19 28l16-16 2.9 3z"}})])
          )
        }
      }
    